import { Package, Truck, Factory, TrendingUp } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { formatKilos } from '@/lib/utils'
import type { DashboardSummary } from '@/types'

interface Props {
  data: DashboardSummary | undefined
  isLoading: boolean
}

const SKELETON = <div className="h-8 w-24 animate-pulse rounded-md bg-gray-100" />

export function SummaryCards({ data, isLoading }: Props) {
  const cards = [
    {
      title: 'Total gestionado',
      icon: Package,
      value: isLoading ? SKELETON : <span className="text-2xl font-bold">{formatKilos(data?.total_kg ?? 0)}</span>,
    },
    {
      title: 'Retiros completados',
      icon: Truck,
      value: isLoading ? SKELETON : <span className="text-2xl font-bold">{data?.completed_pickups ?? 0}</span>,
    },
    {
      title: 'Entregas a destino',
      icon: Factory,
      value: isLoading ? SKELETON : <span className="text-2xl font-bold">{data?.delivery_count ?? 0}</span>,
    },
    {
      title: '% Valorización',
      icon: TrendingUp,
      value: isLoading ? SKELETON : (
        <span className="text-2xl font-bold">{data?.valorization_pct?.toFixed(1) ?? '0.0'}%</span>
      ),
    },
  ]

  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      {cards.map(({ title, icon: Icon, value }) => (
        <Card key={title}>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">{title}</CardTitle>
            <Icon className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>{value}</CardContent>
        </Card>
      ))}
    </div>
  )
}
